import React, { useEffect, useMemo, useRef, useState } from "react";
import * as S from "./GenerativeAI.style";
import * as P from "../../../utils/pipes";
import { useTranslation } from "react-i18next";

// Components
import ChatbotGeneralCase from "./components/cases/chatbotGeneralCase";
import ChatbotPatientCase from "./components/cases/chatbotPatientCase";
import ChatbotProcessCase from "./components/cases/chatbotProcessCase";
import ChatbotGuidanceCase from "./components/cases/chatbotGuidanceCase";
import { useStateValue } from "../../../contextAPI/StateProvider";
import useRecordNavigation from "../../../hooks/useRecordNavigation";
import { Actions } from "../../../utils/actionsIds";
import useDoctorData from "../../../hooks/useDoctorData";
import TransducerView from "../transducerView";
import ChatbotAlgorithmsCase from "./components/cases/chatbotAlgorithmsCase";
import TransductionsHistoryView from "../transductionsHistoryView/TransductionsHistoryView";
import FlorenzButton from "../../florenzComponents/florenzButton/FlorenzButton";
import ChatbotPopUpInfo from "./components/chatbotPopUpInfo";
import ChatbotSelectPatient from "./components/chatbotSelectPatient";
import ChatbotImgReaderCase from "./components/cases/chatbotImgReaderCase";

// assets
const florenceLogo = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-ai.svg`
const bgChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/chat-background.svg`

const ENV = process.env.REACT_APP_ENV;
const REACT_APP_DOCTOR_1_ID_DEMO = process.env.REACT_APP_DOCTOR_1_ID_DEMO;
const REACT_APP_DOCTOR_2_ID_DEMO = process.env.REACT_APP_DOCTOR_2_ID_DEMO;
const REACT_APP_DOCTOR_3_ID_DEMO = process.env.REACT_APP_DOCTOR_3_ID_DEMO;
const REACT_APP_DOCTOR_4_ID_DEMO = process.env.REACT_APP_DOCTOR_4_ID_DEMO;
const REACT_APP_DOCTOR_5_ID_DEMO = process.env.REACT_APP_DOCTOR_5_ID_DEMO;
const REACT_APP_DOCTOR_6_ID_DEMO = process.env.REACT_APP_DOCTOR_6_ID_DEMO;
const REACT_APP_DOCTOR_ID_MEDPALM_ALL_OPTIONS = process.env.REACT_APP_DOCTOR_ID_MEDPALM_ALL_OPTIONS;
const REACT_APP_DOCTOR_ID_MEDPALM_PROD = process.env.REACT_APP_DOCTOR_ID_MEDPALM_PROD;

function GenerativeAI({
  closeFunc,
  maxViewActived,
  setMaxViewActived,
  minimizeActived,
  setMinimizeActived,
  completeViewActived,
  monacoCase
}) {    
  const {t, i18n: { language }} = useTranslation("global");
  const {doctorData} = useDoctorData();
  const { recordAction } = useRecordNavigation();
  const [activeSelectionView, setActiveSelectionView] = useState(false);
  const [activePopUpInfo, setActivePopUpInfo] = useState(false);
  const [activeModalPatient, setActiveModalPatient] = useState(false);

  const [{ 
    florenceView,
    florencePatient,
    florenceProcess,
    florencePartition
   }, dispatch] = useStateValue();


  const chatbotViewsDev = [
    {
      id: 1,
      name: t("chatbotAI.general.title"),
      description: t("chatbotAI.general.subtitle"),
      action: Actions.MONACO.CHAT_GENERAL,
      icon: "zaia-i-generalknowledge",
    },
    // {
    //   id: 3,
    //   name: t("chatbotAI.guidelines.title"),
    //   description: t("chatbotAI.guidelines.subtitle"),
    //   action: Actions.MONACO.CHAT_GUIDES,
    //   icon: "zaia-i-general-view"
    // },
    {
      id: 2,
      name: t("globally.patients"),
      description: t("chatbotAI.patients.subtitle"),
      action: Actions.MONACO.CHAT_PATIENTS,
      icon: "zaia-i-patients"
    },
    {
      id: 4,
      name: t("chatbotAI.guidelines.title"),
      description: t("chatbotAI.guidelines.subtitle"),
      action: Actions.MONACO.CHAT_GUIDES_AND_PATIENTS,
      icon: "zaia-i-user-card"
    },
    {
      id: 5,
      name: t("globally.monacoAlgorithms"),
      description: t("chatbotAI.algorithms.subtitle"),
      action: Actions.MONACO.MONACO_ALGORITHMS,
      icon: "zaia-i-monacoalgorithms"
    },
    {
      id: 6,
      name: t("globally.medicalTransductor"),
      description: t("chatbotAI.medicalTransductor.subtitle"),
      action: Actions.MONACO.MEDICAL_TRANSDUCTOR,
      icon: "zaia-i-medicaltransductor"
    },
    {
      id: 7,
      name: t("chatbotAI.medicalTransductorHistory.title"),
      description: t("chatbotAI.medicalTransductorHistory.subtitle"),
      action: Actions.MONACO.MEDICAL_TRANSDUCTOR_HISTORY,
      icon: "zaia-timeline"
    },
    {
      id: 8,
      name: t("chatbotAI.imageReading.title"),
      description: t("chatbotAI.imageReading.subtitle"),
      action: Actions.MONACO.CHAT_IMAGE_READING,
      icon: "zaia-icono-gallery"
    },
    {
      id: 9,
      name: t("chatbotAI.navigatonModule.title"),
      description: t("chatbotAI.navigatonModule.subtitle"),
      action: Actions.MONACO.CHAT_GUIDE_NAVIGATION_MODULE,
      icon: "zaia-i-user-card"
    }
  ]

  const chatbotViewsProd = [
    {
      id: 1,
      name: t("chatbotAI.general.title"),
      description: t("chatbotAI.general.subtitle"),
      action: Actions.MONACO.CHAT_GENERAL,
      icon: "zaia-i-generalknowledge"
    },
    {
      id: 4,
      name: t("chatbotAI.guidelines.title"),
      description: t("chatbotAI.guidelines.subtitle"),
      action: Actions.MONACO.CHAT_GUIDES_AND_PATIENTS,
      icon: "zaia-i-user-card"
    },
    // {
    //   id: 3,
    //   name: t("chatbotAI.guidelines.title"),
    //   description: t("chatbotAI.guidelines.subtitle"),
    //   action: Actions.MONACO.CHAT_GUIDES,
    //   icon: "zaia-i-general-view"
    // },
    {
      id: 5,
      name: t("globally.monacoAlgorithms"),
      description: "",
      action: Actions.MONACO.MONACO_ALGORITHMS,
      icon: "zaia-i-monacoalgorithms"
    },
    {
      id: 6,
      name: t("globally.medicalTransductor"),
      description: "",
      action: Actions.MONACO.MEDICAL_TRANSDUCTOR,
      icon: "zaia-i-medicaltransductor"
    },
    {
      id: 8,
      name: t("chatbotAI.imageReading.title"),
      description: t("chatbotAI.imageReading.subtitle"),
      action: Actions.MONACO.CHAT_IMAGE_READING,
      icon: "zaia-icono-gallery"
    },
    {
      id: 9,
      name: t("chatbotAI.navigatonModule.title"),
      description: t("chatbotAI.navigatonModule.subtitle"),
      action: Actions.MONACO.CHAT_GUIDE_NAVIGATION_MODULE,
      icon: "zaia-i-user-card"
    }
  ]

  const demoUsersProdFilter = useMemo(() => {
    return ENV === 'production' ? 
      REACT_APP_DOCTOR_1_ID_DEMO === doctorData?.id ||
      REACT_APP_DOCTOR_2_ID_DEMO === doctorData?.id ||
      REACT_APP_DOCTOR_3_ID_DEMO === doctorData?.id ||
      REACT_APP_DOCTOR_4_ID_DEMO === doctorData?.id ||
      REACT_APP_DOCTOR_5_ID_DEMO === doctorData?.id ||
      REACT_APP_DOCTOR_6_ID_DEMO === doctorData?.id ||
      REACT_APP_DOCTOR_ID_MEDPALM_ALL_OPTIONS === doctorData?.id ||
      REACT_APP_DOCTOR_ID_MEDPALM_PROD === doctorData?.id
    : true;
  }, [doctorData]);


  useEffect(() => {
    if(monacoCase){
      changeView(monacoCase);
    }
  }, [monacoCase])

  const changeView = (view) => {
    dispatch({
      type: "SET_FLORENCE_VIEW",
      florenceView: view,
    });
    selectPatient();
    selectProcess();
    selectPartition();
  } 

  const selectPatient = (patient) => {
    dispatch({
      type: "SET_FLORENCE_PATIENT",
      florencePatient: patient,
    });
  }

  const selectProcess = (process) => {
    dispatch({
      type: "SET_FLORENCE_PROCESS",
      florenceProcess: process,
    });
  }

  const selectPartition = (partition) => {
    dispatch({
      type: "SET_FLORENCE_PARTITION",
      florencePartition: partition,
    });
  }

  const closeAction = () => {
    closeFunc(false);
    setMinimizeActived(false);
    setMaxViewActived(false);
    changeView(1)
  }

  return (
    <S.GenerativeAI
      maxViewActived={maxViewActived}
      florenceView={florenceView}
    >
      {
        (activeSelectionView || activePopUpInfo || activeModalPatient) &&
        <div className="chatbot__pop-up">
          {
            activeSelectionView &&
            <ChatbotChooseOptions
              setChatbotViewSelected={changeView}
              chatbotViews={demoUsersProdFilter ? chatbotViewsDev : chatbotViewsProd}
              setActiveSelectionView={setActiveSelectionView}
            />
          }
          {
            activePopUpInfo &&
            <ChatbotPopUpInfo
              florenceView={florenceView}
              setActivePopUpInfo={setActivePopUpInfo}
            />
          }  
          {
            activeModalPatient &&
            <ChatbotSelectPatient
              closeFunc={() => setActiveModalPatient(false)}
              selectPatient={selectPatient}
            /> 
          }
        </div>
      }
      {/* {
        florencePartition &&
        <div className="partition-selected">
          <div className="partition-selected__container">
            <div className="partition-selected__point"></div>
            <div className="partition-selected__text">
              {florencePartition.text}
            </div>
          </div>
        </div>
      } */}

      {
        florenceView === 7 &&
        <TransductionsHistoryView 
          closeFunc={closeAction}
          maxViewActived={maxViewActived}
          setMaxViewActived={setMaxViewActived}
          minimizeActived={minimizeActived}
          setMinimizeActived={setMinimizeActived}
          changeView={changeView}
        /> 
      }
      {
        florenceView === 6 &&
        <TransducerView 
          closeFunc={closeAction}
          maxViewActived={maxViewActived}
          setMaxViewActived={setMaxViewActived}
          minimizeActived={minimizeActived}
          setMinimizeActived={setMinimizeActived}
          changeView={changeView}
          completeViewActived={completeViewActived}
          resetDisabled={monacoCase}
          setActiveSelectionView={setActiveSelectionView}
        /> 
      }
      {
        (florenceView <= 5 || florenceView === 8 || florenceView === 9) &&
        <div className="chatbot">
          <Header 
            closeFunc={closeAction}
            setChatbotViewSelected={changeView}
            chatbotViewSelected={florenceView}
            chatbotViews={demoUsersProdFilter ? chatbotViewsDev : chatbotViewsProd}
            processNameSelected={P.dataTranslation(florenceProcess?.processName, language)}
            maxViewActived={maxViewActived}
            setMaxViewActived={setMaxViewActived}
            minimizeActived={minimizeActived}
            setMinimizeActived={setMinimizeActived}
            completeViewActived={completeViewActived}
            florenceView={florenceView}
            resetDisabled={monacoCase}
            selectProcess={selectProcess}
            selectPartition={selectPartition}
            setActiveSelectionView={setActiveSelectionView}
            setActivePopUpInfo={setActivePopUpInfo}
          />
          <div className="chatbot-content">
            {/* {
              florenceView === 0 &&
              
            } */}
            {
              florenceView === 1 &&
              <ChatbotGeneralCase/>
            }
            {
              florenceView === 2 &&
              <ChatbotPatientCase
                selectedPatient={florencePatient}
                // selectPatient={selectPatient}
                setActiveModalPatient={setActiveModalPatient}
              />
            }
            {/* {
              florenceView === 3 &&
              <ChatbotProcessCase
                selectedProcess={florenceProcess}
                selectedPartition={florencePartition}
                selectProcess={selectProcess}
                selectPartition={selectPartition}
              />
            } */}
            {
              florenceView === 4 &&
              <ChatbotGuidanceCase
                selectedPatient={florencePatient}
                selectedProcess={florenceProcess}
                selectedPartition={florencePartition}
                selectPatient={selectPatient}
                selectProcess={selectProcess}
                selectPartition={selectPartition}
                setActiveModalPatient={setActiveModalPatient}
              />
            }
            {
              florenceView === 5 &&
              <ChatbotAlgorithmsCase
                selectedPatient={florencePatient}
                selectedProcess={florenceProcess}
                selectedPartition={florencePartition}
                selectPatient={selectPatient}
                selectProcess={selectProcess}
                selectPartition={selectPartition}
              />  
            }
            {
              florenceView === 8 &&
              <ChatbotImgReaderCase/>
            }
            {
              florenceView === 9 &&
              <ChatbotGuidanceCase
                selectedPatient={florencePatient}
                selectedProcess={florenceProcess}
                selectedPartition={florencePartition}
                selectPatient={selectPatient}
                selectProcess={selectProcess}
                selectPartition={selectPartition}
                setActiveModalPatient={setActiveModalPatient}
                isNavigationModule={true}
              />
            }
          </div>
        </div>
      }
    </S.GenerativeAI>
  );

}

const Header = ({ 
  closeFunc, 
  setChatbotViewSelected,
  chatbotViewSelected,
  chatbotViews,
  processNameSelected,
  maxViewActived,
  setMaxViewActived,
  minimizeActived,
  setMinimizeActived,
  completeViewActived,
  florenceView,
  resetDisabled,
  selectProcess,
  selectPartition,
  setActiveSelectionView,
  setActivePopUpInfo
}) => {

  const {t, i18n: { language }} = useTranslation("global");

  return (
    <S.HeaderDiv
      completeViewActived={completeViewActived}
      florenceView={florenceView}
    >
      <div className="header">
        <div className="header__top">
          <div className="header__left">
            {/* <div className="header__title"> */}
              {/* <img className="header__title-logo" src={florenceLogo} alt={t("globally.chatbotName")} /> */}
              {
                chatbotViewSelected !== 0 && !resetDisabled &&
                <>
                  <div className="header__info-button">
                    <FlorenzButton
                      size={"s"}
                      icon={"zaia-i-info"}
                      iconSize={"14px"}
                      typeStyle={"outline"}
                      onClick={() => setActivePopUpInfo(true)}
                    />
                  </div>
                  <div className="header__return-button">
                    <FlorenzButton
                      size={"s"}
                      icon={"zaia-i-refresh"}
                      iconSize={"17px"}
                      typeStyle={"primary"}
                      text={t("chatbotAI.changeMode")}
                      onClick={() => setActiveSelectionView(true)}
                    />
                  </div>
                </>
              }
            {/* </div>  */}
          </div>
          {/* {
            chatbotViewSelected !== 0 && !resetDisabled &&
            <div className="header__reset-button" onClick={() => setChatbotViewSelected(0)}>{t("chatbotAI.reset")}</div>
          } */}
          <div className="header__right">
            {
              !completeViewActived &&
              <>
                <div className="header__close-chat" onClick={() => closeFunc(false)}>
                  <i className="header__close-chat-icon icon zaia-icono-cerrar" />
                </div>
                <div className="header__max" onClick={() => setMaxViewActived(!maxViewActived)}>
                  {
                    maxViewActived
                    ? <i className="header__max-icon icon zaia-icono-flechas-arriba-abajo ~changeicon" />
                    : <i className="header__max-icon icon zaia-i-size" />
                  }
                </div>
              </>
            }
          </div>
        </div>
        <div className="header__bottom">
          {
            chatbotViewSelected !== 0 &&
            <div className="header__subtitle">
              <div className="header__subtitle-label">
                {t("chatbotAI.mode")}: 
              </div>
              {
                chatbotViewSelected === 0
                ? t("chatbotAI.generalCase")
                : chatbotViews.find((item) => item.id === chatbotViewSelected)?.name
              }
            </div>
          }
            {/* {
              processNameSelected &&
              <div className="header__process-name">
                {processNameSelected}
                <button className="header__process-close"
                  onClick={() => {
                    selectProcess(null)
                    selectPartition(null)
                  }}
                >
                  <i className="header__process-close-icon icon zaia-icono-cerrar"></i>
                </button>
              </div>
            } */}
        </div>
      </div>
    </S.HeaderDiv>
  );
};

const ChatbotChooseOptions = ({ 
  setChatbotViewSelected,
  chatbotViews,
  setActiveSelectionView
}) => {
  const { recordAction } = useRecordNavigation();
  const {t} = useTranslation("global");

  return (
    <S.ChatbotChooseOptions>
      <div className="header">
        <div className="header__left"
          onClick={() => {
            setActiveSelectionView(false);
          }}
        >
          <i className="header__icon icon zaia-icono-atras"></i>
          <div className="header__text">
            {t("globally.back")}
          </div>
        </div>
        <div className="header__right">
          <div className="header__title">
            {t("chatbotAI.listModels")}
          </div>
        </div>
      </div>
      <div className="view-options">
        {
          (
            chatbotViews
          ).map(
            (view) => {
              return(
                <div 
                  className="view-option"
                  key={view.id}
                >
                  <button 
                    className="view-option__button" 
                    onClick={() => {
                      recordAction(view.action);
                      setChatbotViewSelected(view.id)
                      setActiveSelectionView(false);
                    }}
                  >
                    <div className="view-option__button-text-container">
                      <div className="view-option__button-text">{view.name}</div>
                      {
                        view.description &&
                        <div className="view-option__button-text-description">{view.description}</div>
                      }
                    </div>
                    <i className={`view-option__button-icon icon ${view.icon}`} />
                  </button>
                </div>
              )
            }
          )
        }
      </div>
    </S.ChatbotChooseOptions>
  );
};

export default GenerativeAI;
